class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onSummaryClick(event) {
    if (this.mainDetailsToggle.hasAttribute('open') && this.mainDetailsToggle.dataset.closing !== 'true') {
      event.preventDefault();
      this.close();
    }
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || this.mainDetailsToggle.dataset.closing === 'true') {
      this.mainDetailsToggle.removeAttribute('open');
      return;
    }

    this.mainDetailsToggle.dataset.closing = 'true';
    this.mainDetailsToggle.classList.add('menu-closing');

    const finish = () => {
      this.mainDetailsToggle.classList.remove('menu-closing');
      this.mainDetailsToggle.removeAttribute('open');
      delete this.mainDetailsToggle.dataset.closing;
    };

    const submenu =
      this.mainDetailsToggle.querySelector(':scope > .header__submenu') ||
      this.mainDetailsToggle.querySelector(':scope > .mega-menu__content');
    if (submenu) {
      const onEnd = (e) => {
        if (e.target !== submenu) return;
        submenu.removeEventListener('animationend', onEnd);
        submenu.removeEventListener('transitionend', onEnd);
        finish();
      };
      submenu.addEventListener('animationend', onEnd);
      submenu.addEventListener('transitionend', onEnd);
      setTimeout(finish, 400);
    } else {
      finish();
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
